const io = require('socket.io-client');

const { SOCKET_LS_URL } = require('./config');

const socket = io(SOCKET_LS_URL);

exports = module.exports = socket;
